var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9016 17.2091C25.9016 16.5516 25.8425 15.9194 25.733 15.3125H17V18.8991H21.9903C21.7753 20.0581 21.122 21.0401 20.14 21.6976V24.024H23.1367C24.89 22.4099 25.9016 20.0328 25.9016 17.2091Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9971 26.2715C19.5007 26.2715 21.5996 25.4413 23.1338 24.0253L20.1371 21.6991C19.3068 22.2553 18.2447 22.5841 16.9971 22.5841C14.5821 22.5841 12.5379 20.9531 11.8088 18.7617H8.71094V21.1639C10.2367 24.1939 13.3725 26.2715 16.9971 26.2715Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8107 18.7616C11.6252 18.2053 11.5198 17.6111 11.5198 16.9999C11.5198 16.3888 11.6252 15.7946 11.8107 15.2383V12.8359H8.71281C8.08482 14.0877 7.72656 15.5038 7.72656 16.9999C7.72656 18.4961 8.08482 19.9122 8.71281 21.164L11.8107 18.7616Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9971 11.414C18.3585 11.414 19.5808 11.8818 20.5417 12.8005L23.2013 10.1413C21.5954 8.64527 19.4965 7.72656 16.9971 7.72656C13.3725 7.72656 10.2367 9.8042 8.71094 12.8343L11.8088 15.2364C12.5379 13.045 14.5821 11.414 16.9971 11.414Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.8cf79148f50f927a596203ad5aa1241d.svg";
export { ForwardRef as ReactComponent };